import searchContacts from 'api/scheduler/searchContacts';

/**
 * Fetch all guards (contacts/employees) from the API
 * Transforms API response to match expected format: { id, name }
 * @returns {Promise<Array>} Promise that resolves to an array of guard objects
 */
export const fetchGuards = async () => {
  const { data } = await searchContacts('', 1, 500);

  // Transform API response to match expected format
  return data.map((contact) => ({
    id: contact.Id,
    name: contact.FullName,
    // Preserve original fields for reference
    originalData: contact,
  }));
};

/**
 * Fetch a guard by ID
 * @param {number|string} guardId - The ID of the guard
 * @returns {Promise<Object|null>} Promise that resolves to a guard object or null
 */
export const fetchGuardById = async (guardId) => {
  const guards = await fetchGuards();
  return guards.find((g) => g.id === guardId || g.id === String(guardId)) || null;
};

/**
 * Fetch a guard by name
 * @param {string} guardName - The name of the guard
 * @returns {Promise<Object|null>} Promise that resolves to a guard object or null
 */
export const fetchGuardByName = async (guardName) => {
  const guards = await fetchGuards();
  return guards.find((g) => g.name === guardName) || null;
};
